'use strict';

var angular = require('angular');
module.exports = angular.module('AVRO.Widgets.MultiCheckboxGroup', ['msieurtoph.ngCheckboxes']).directive('rmMultiCheckboxGroup', require('./directives/MultiCheckboxGroupDirective'));